import { render } from "./MyPhotoView.vue?vue&type=template&id=6a2f6474"
import script from "./MyPhotoView.vue?vue&type=script&lang=js"
export * from "./MyPhotoView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__